import axios from 'axios';
import { ConsultaListaTurmasCursadasServiceProps, Service } from './consulta-lista-turmas-cursadas.types';

export const consultaListaTurmasCursadasService: Service<ConsultaListaTurmasCursadasServiceProps> = async ({
  urlBase,
  token,
  periodoAcademico,
}) => {
  const periodoQueryParam = periodoAcademico ? `&periodo=${periodoAcademico}` : '';

  const path = `${urlBase}/v2.2/entregas?status=CURSADA${periodoQueryParam}`;
  const authorization = `Bearer ${token}`;

  const { data } = await axios.get(path, { headers: { authorization } });

  return data;
};
